module.exports = __webpack_public_path__ + "static/media/doTERRA-launch-guide.650d8ba0.pdf";